import React, { useContext, useEffect, useState } from "react";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import AppSettings from "../../../../Settings/AppSettings";
import { CategoryContext } from "../CategoryContext";
import { arrayMove, List } from "react-movable";
import Label from "../../../Common/components/Label";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import SmallOutlinedButton from "../../../Common/components/SmallOutlinedButton";
import SmallFillButton from "../../../Common/components/SmallFillButton";
import { toast } from "react-toastify";
import { AppContext } from "../../../../Context/AppContext";
import ViewMoreButton from "../../../Common/components/ViewMoreButton";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

const _max_items_show = 15
const PdwAttributeOrder = () => {
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const { editingItem } = useContext(CategoryContext);
  const [loading, setLoading] = useState({ status: "", message: "", });
  const [list, setList] = useState(null);
  const [EditPage, setEditPage] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const appData = useContext(AppContext);
  const [pdwAttributeOrder, setPdwAttributeOrder] = useState(null);
  const [viewMore, setViewMore] = useState(false);

  useEffect(() => {
    setPdwAttributeOrder(null);
    setLoading({ status: "", message: "", });
  }, [editingItem.id]);

  useEffect(() => {
    if (list === null && collapse) {
      load_associated_pdw_attributes();
    }
  }, [collapse]);

  useEffect(() => {
    if (EditPage) {
      load_associated_pdw_attributes();
    }
  }, [EditPage]);

  async function load_associated_pdw_attributes() {
    setLoading({ status: "Loading", message: "Loading Pdw Attribute Order" });
    const res = await ServiceWrapper.doGet(
      `${api_base_url}category/${editingItem.id}/pdwattributes/list`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "Success", message: undefined });
      setPdwAttributeOrder(res.data.data);
      setList(res.data.data);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }

  async function handle_save() {
    setLoading({ status: "Loading", message: "Saving new order for PDW attributes", });
    const newOrder = list.map((item, index) => ({ id: item.id, column_order: `${index + 1}`, }));
    const res = await ServiceWrapper.doPost(
      `${api_base_url}category/${editingItem.id}/pdwattributes/edit`,
      newOrder,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      if (res.data.done) {
        setLoading({ status: "Success", message: res.data.message, });
        setEditPage(false);
        load_associated_pdw_attributes();
      } else {
        setLoading({ status: "Error", message: res.data.message, });
      }
    } else {
      setLoading({ status: "Error", message: "Error while saving, Please try after some time.", });
    }
    setTimeout(() => {
      if (loading.status !== "Success")
        setLoading({ status: "", message: "", });
    }, 5000);
  }

  function handle_cancel() {
    setEditPage(false);
    setList(pdwAttributeOrder);
  }

  return (
    <>
      <div className="accordion" id="accordionFlushPdw">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed shadow-none"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapsePdw"
            aria-expanded="false"
            aria-controls="flush-collapsePdw"
            // style={Utils.borderStyle()}
            style={{
              height: "2.6875rem",
              border: "1px solid #c9cccf",
            }}
          >
            <div>
              {EditPage ? <Label message="Update " /> : ""}{" "}
              <Label message=" PDW Attribute Order" />
            </div>
          </div>
          {collapse && (
            <>
              {loading.status === "Success" && (
                <>
                  {!EditPage ? (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      {pdwAttributeOrder && pdwAttributeOrder.length > 1 && (
                        <GMSBorderlessButton
                          name="Edit"
                          onClick={() => {
                            if (
                              appData.pm.checkPermission("gmscategory_update")
                            ) {
                              setEditPage(true);
                            } else {
                              toast.info(
                                "You don't have permission to edit PDW Attribute order"
                              );
                            }
                          }}
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      className="d-inline-block d-flex float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "30px",
                      }}
                    >
                      <GMSBorderlessButton
                        name="Reset"
                        onClick={() => setList(pdwAttributeOrder)}
                        disabled={
                          JSON.stringify(pdwAttributeOrder) ===
                          JSON.stringify(list)
                        }
                      />
                      
                      &nbsp;
                      <SmallOutlinedButton
                        name="Cancel"
                        onClick={() => {
                          handle_cancel();
                        }}
                      />
                      &nbsp;
                      <SmallFillButton
                        name="Save"
                        disabled={
                          JSON.stringify(pdwAttributeOrder) ===
                          JSON.stringify(list)
                        }
                        onClick={() => handle_save()}
                      />
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <div
            id="flush-collapsePdw"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingPdw"
            data-bs-parent="#accordionFlushPdw"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              <LoadingSuccessErrorAlert loading={loading} />

              {loading.status === "Success" && (
                <>
                  {EditPage ? (
                    <div
                      className="card p-2 bg-body"
                      style={{
                        borderBottom: "1px solid #c9cccf",
                        borderLeft: "1px solid #c9cccf",
                        borderRight: "1px solid #c9cccf",
                        borderTop: "none",
                      }}
                    >
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th
                              className="border-0"
                              scope="col"
                              style={{
                                fontFamily: "Noto Sans",
                                fontSize: "0.875rem",
                                fontWeight: 400,
                                paddingBottom: "13px",
                                color: "#787878",
                              }}
                            >
                              PDW Attribute Order Ranking
                            </th>
                          </tr>
                        </thead>
                        <List
                          values={list}
                          onChange={({ oldIndex, newIndex }) =>
                            setList(arrayMove(list, oldIndex, newIndex))
                          }
                          renderList={({ children, props }) => (
                            <tbody {...props}>{children}</tbody>
                          )}
                          renderItem={({ value, isDragged, props }) => (
                            <tr className="tw-bg-white">
                              <td className="border-0" {...props}>
                                <span className="tw-flex tw-items-center tw-py-1.5 tw-px-2 tw-gap-2 tw-bg-[#F4F4F7]">
                                  <img alt="drag_icon" src={process.env.PUBLIC_URL + "/img/Group 17.svg"} />
                                  {props.key !== undefined && `${props.key + 1}. `} {value.name}
                                </span>
                              </td>
                            </tr>
                          )}
                          transitionDuration={100}
                          lockVertically={true}
                        />
                      </table>
                    </div>
                  ) : (
                    <div
                      className="p-3"
                      style={{
                        borderBottom: "1px solid #d6d8d9",
                        borderRight: "1px solid #d6d8d9",
                        borderLeft: "1px solid #d6d8d9",
                        borderTop: "none",
                      }}
                    >
                      {pdwAttributeOrder && pdwAttributeOrder.length > 0 ? (
                        <table className="table table-sm border-none">
                          <tbody>
                          {
                            pdwAttributeOrder.slice(0, 
                              (viewMore) 
                              ? pdwAttributeOrder.length : Math.min(_max_items_show, pdwAttributeOrder.length)
                              ).map((item, index) => {
                              let pdwName = `${index + 1}  ${item.name}`;
                              return (
                                <tr key={index}>
                                  <Label
                                    message={pdwName}
                                    fontWeight="400"
                                    fontSize={0.75}
                                    color="#5c5f62"
                                    fontFamily="Noto Sans"
                                  />
                                </tr>
                              );
                            })}
                            <tr>
                              <ViewMoreButton
                                state = {viewMore}
                                handleClick= {() => setViewMore(!viewMore)}
                                condition = {pdwAttributeOrder?.length > _max_items_show}
                              />
                            </tr>
                          </tbody>
                        </table>
                      ) : (
                        <div
                          className="alert alert-dark small p-2"
                          role="alert"
                        >
                          <strong>PDW attributes Not Found</strong>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default PdwAttributeOrder;


